import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppVersionService {
  private http = inject(HttpClient);

  //#region prop
  private versionFileUrl = 'version.json';
  appVersion = signal<string>('');
  static appVersion: string;

  async getVersion(): Promise<any> {
    if (this.appVersion()) return;
    const data =
      (await lastValueFrom(this.http.get(this.versionFileUrl))) || null;
    const version = data?.['version'];
    this.appVersion.set(version);
    AppVersionService.appVersion = version;
    return data;
  }
}
